/*
 * Valenor — Scroll reveal observer.
 * Flips [data-vln-reveal] to [data-vln-reveal="in"] when the element enters
 * the viewport. Respects prefers-reduced-motion and gracefully falls through
 * when IntersectionObserver is unavailable (shows all immediately).
 *
 * Runs once; re-scans when Shopify theme editor hydrates a new section/block.
 */
(() => {
  if (typeof window === 'undefined' || window.__vlnRevealInit) return;
  window.__vlnRevealInit = true;

  const prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const showAll = () => {
    document
      .querySelectorAll('[data-vln-reveal]:not([data-vln-reveal="in"])')
      .forEach((el) => el.setAttribute('data-vln-reveal', 'in'));
  };

  if (prefersReduced || !('IntersectionObserver' in window)) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showAll, { once: true });
    } else {
      showAll();
    }
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-vln-reveal', 'in');
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  const scan = () => {
    document
      .querySelectorAll('[data-vln-reveal]:not([data-vln-reveal="in"])')
      .forEach((el) => observer.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:load', scan);
})();
